import memoizeWithAllArguments from "@gef-ui/utils/memoizeWithAllArguments";
import path from "ramda/es/path";
import curry from "ramda/es/curry";
import defaultTo from "ramda/es/defaultTo";
import flip from "ramda/es/flip";
import identity from "ramda/es/identity";
import keys from "ramda/es/keys";
import o from "ramda/es/o";
import prop from "ramda/es/prop";
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import notEqual from "ramda-extension/es/notEqual";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../../constants/registeredFields';
/**
 * get registered fields for given form
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getRegisteredFields('formName')(state)
 *
 */ export const getRegisteredFields = memoizeWithIdentity((formName)=>createSelector(path([
        formName,
        REDUCER_NAME
    ]), identity));
/**
 * get registered fields names for given form
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getRegisteredFieldsNames('formName')(state)
 *
 */ export const getRegisteredFieldsNames = memoizeWithIdentity((formName)=>createSelector(getRegisteredFields(formName), keys));
/**
 * get registered field for given form
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getRegisteredField('formName')(state)('fieldName')
 *
 */ export const getRegisteredField = memoizeWithIdentity((formName)=>createSelector([
        getRegisteredFields(formName)
    ], memoizeWithAllArguments(flip(prop))));
const statePath = (value)=>curry((fields, fieldName)=>defaultTo(true, path([
            fieldName,
            'state',
            value
        ], fields)));
/**
 * check if registered field is pristine
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	isRegisteredFieldFieldPristine('formName')(state)('fieldName')
 *
 */ export const isRegisteredFieldFieldPristine = memoizeWithIdentity((formName)=>createSelector([
        getRegisteredFields(formName)
    ], memoizeWithAllArguments(statePath('pristine'))));
/**
 * check if registered field is valid. Does not contain severity ERROR
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	isRegisteredFieldFieldValid('formName')(state)('fieldName')
 *
 */ export const isRegisteredFieldFieldValid = memoizeWithIdentity((formName)=>createSelector([
        getRegisteredFields(formName)
    ], (fields)=>{
        const validator = statePath('valid')(fields);
        return o(notEqual('ERROR'), validator);
    }));
